import React from "react";

const Footer = () => {
  return (
    <div>
    <footer>
      <h4>
      &#60;&#47;&#62; with ❤️ & ☕ by{" "}
      <a 
         style={{
             textDecoration:"none",
             color:"white",
      }}

      href="anshumdwivedi.vercel.app"
      target="_blank"
      rel="noreferrer"
      >
        Anshum Dwivedi
     </a>
      </h4>
    </footer>
  </div>

  );
};

export default Footer;